export default __webpack_public_path__ + "static/media/rousingshock.bdf0b4d2.png";